import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/navigation.css'
import linkedIn from '../assets/images/linkedin.png';
import gitHub from '../assets/images/github.svg';
import ProjectsPage from '../pages/ProjectsPage';

function Navigation (props) {
  const handleClick = () => {
    props.setLanding(2)
  }
  const toggleMenu = () => {
    const x = document.getElementById('myTopnav');
    if (x.className === 'navigation-container') {
      x.className += ' responsive';
    } else {
      x.className = 'navigation-container';
    }
  };
  return (
    <div id="myTopnav" className="navigation-container">
      <Link
        to="/"
        className="button"
        onClick={handleClick}>

        <div className="navigation-name">David Beale</div>
      </Link>
      <div className="navigation-links-container">
        <Link
          className="button"
          onClick={handleClick}
          to="/"
        >
          <div>Home</div>
        </Link>
        <Link
          className="button"
          onClick={toggleMenu}
          to="/projects"
        >
          <div>Projects</div>
        </Link>
        <Link
          className="button"
          onClick={toggleMenu}
          to="/about"
        >
          <div>About</div>
        </Link>
        <Link
          className="button"
          onClick={toggleMenu}
          to="/contact"
        >
          <div>Contact</div>
        </Link>
        <a href="https://www.linkedin.com/in/david-a-beale" rel="noopener noreferrer" target="_blank">
          <img className="icon" src={linkedIn} alt="linkedIn" ></img>
        </a>
        <a href="https://github.com/David-Beale" rel="noopener noreferrer" target="_blank">
          <img className="icon" src={gitHub} alt="github" ></img>
        </a>
        <a className="navicon" onClick={toggleMenu}>
          &#9776;
        </a>
      </div>
    </div>
  )
}

export default Navigation